import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from '../../PartnerOptions/constants'
import { INCIDENT_REQUEST_ASYNC as ATO_REPORT_REQUEST_ASYNC } from '../AtoIncident/constants'
import { INCIDENT_TYPE } from '../constants'
import { REPORT_SELECT, URL_STATE_CHANGE } from '../List/constants'
import { COMMENTS_REQUEST_ASYNC } from '../ReportComments/constants'
import { EDIT_TAGS_REQUEST_ASYNC, TAGS_REQUEST_ASYNC } from '../TagsClassification/constants'

import {
  ACTION_STATE_CHANGE_TO_STATE,
  CLOSE_INCIDENT_ASYNC,
  CLOSE_SAFE_CHALLENGE_INCIDENT_ASYNC,
  DOWNLOAD_ORIGINAL_EMAIL_ASYNC,
  EMAIL_CONTENT_TYPE,
  EMAIL_SNAPSHOT_ASYNC,
  EMAIL_TABS_KEYS,
  FETCH_AFFECTED_MAILBOXES_COUNTS_ASYNC,
  FETCH_ASSIGNEES_ASYNC,
  FETCH_COMMUNITY_INSIGHTS_ASYNC,
  FETCH_PAGINATED_REPORTERS_ASYNC,
  FETCH_REPORT_ELEMENTS_ASYNC,
  FETCH_SCANS_FREEMIUM_LIMIT_ASYNC,
  KEEP_ENCRYPTED_INCIDENT_IN_QUARANTINE_ASYNC,
  RELEASE_ENCRYPTED_INCIDENT_ASYNC,
  RELEASE_MSFT_QUARANTINE_REPORT_ASYNC,
  REPORT_ELEMENTS_REQUEST_ASYNC,
  REPORT_ELEMENTS_UPDATE_ASYNC,
  REPORT_REQUEST_ASYNC,
  REPORT_STATE_CHANGE_ASYNC,
  REQUEST_THEMIS_GENERATE_ASYNC,
  SET_ESCALATED_EMAIL_CARD_TAB_KEY,
  SHOW_AFFECTED_MAILBOXES_VIEW,
  SHOW_SCANNER_DETAILS_VIEW,
  statusKeyMap,
  THEMIS_ANALYSIS_ASYNC,
  THEMIS_ANALYSIS_PARTIAL_UPDATE,
  THEMIS_MAX_RETRIES,
} from './constants'

const CACHE_THEMIS_ANALYSIS_RESULTS = false

const affectReportForElements = (report, elements, elementsName) => {
  const updatedReport = { ...report }
  if (!elementsName || elementsName === 'attachments') {
    updatedReport.attachments = elements.filter((e) => e.otype === 1).map((e) => ({ ...e }))
  }
  if (!elementsName || elementsName === 'links') {
    updatedReport.links = elements.filter((e) => e.otype === 2).map((e) => ({ ...e }))
  }
  if (elementsName === 'serversidescan') {
    updatedReport.scans = elements
  }
  return updatedReport
}

export default function () {
  const initialState = {
    data: {},
    snapshotUrl: null,
    emailSnapshotLoader: false,
    communityInsights: {},
    communityLoader: false,
    reportLoader: true,
    error: null,
    scannerDetails: null,
    affMailboxesDetails: null,
    affMailboxesDetailsForceEndUsers: false,
    affMailboxesCounts: {},
    scansFreemiumLimit: {},
    assignees: {
      loader: false,
      error: null,
      data: [],
    },
    downloadOriginalEmailLoader: false,
    isShowAccountTakeOverPopup: false,
    escalatedEmailCardTabKey: EMAIL_TABS_KEYS.EMAIL_BODY,
    reportElements: {
      loader: false,
      error: null,
      links: {},
      files: {},
    },
    reportersPagination: {},
    reportersLoading: false,
    msftActionLoaderByReportKey: {},
    themisAnalysis: {
      byReportId: {},
    },
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case CLOSE_INCIDENT_ASYNC.INITIATE:
      case CLOSE_SAFE_CHALLENGE_INCIDENT_ASYNC.INITIATE:
        return {
          ...state,
          reportLoader: true,
          escalatedEmailCardTabKey: EMAIL_TABS_KEYS.EMAIL_BODY,
          error: null,
          // New seq per confirm. The drawer reuses the classify leave plan
          // while this row is still in the list; a repeated id alone would
          // not signal a second attempt after a failed close.
          closeRequest: {
            reportId: action.payload?.reportId,
            seq: (state.closeRequest?.seq || 0) + 1,
          },
        }
      case REPORT_SELECT:
      case URL_STATE_CHANGE:
      case REPORT_STATE_CHANGE_ASYNC.INITIATE:
      case RELEASE_ENCRYPTED_INCIDENT_ASYNC.INITIATE:
      case KEEP_ENCRYPTED_INCIDENT_IN_QUARANTINE_ASYNC.INITIATE:
        return {
          ...state,
          reportLoader: true,
          escalatedEmailCardTabKey: EMAIL_TABS_KEYS.EMAIL_BODY,
          error: null,
        }
      case REPORT_STATE_CHANGE_ASYNC.SUCCESS: {
        const replacer =
          action.payload.newState === 'delete' ||
          action.payload.reportType === INCIDENT_TYPE.POTENTIAL_MAIL ||
          action.payload.reportType === INCIDENT_TYPE.AUTO_THEMIS_POTENTIAL_MAIL
            ? { removed: true }
            : {
                state:
                  ACTION_STATE_CHANGE_TO_STATE[action.payload.reportType][action.payload.newState],
              }
        return {
          ...state,
          reportLoader: false,
          data: {
            ...state.data,
            ...replacer,
          },
          // Potential classify/delete returns an empty 200, so response is null.
          isShowAccountTakeOverPopup:
            action.payload.data?.response?.showAccountTakeOverPopup ?? false,
        }
      }
      case RELEASE_MSFT_QUARANTINE_REPORT_ASYNC.INITIATE: {
        const key = `${INCIDENT_TYPE.MSFT}-${action.payload.reportId}`
        return {
          ...state,
          msftActionLoaderByReportKey: {
            ...state.msftActionLoaderByReportKey,
            [key]: true,
          },
        }
      }
      case RELEASE_MSFT_QUARANTINE_REPORT_ASYNC.SUCCESS:
      case RELEASE_MSFT_QUARANTINE_REPORT_ASYNC.ERROR: {
        const key = `${INCIDENT_TYPE.MSFT}-${action.payload?.reportId || state.data.id}`
        return {
          ...state,
          msftActionLoaderByReportKey: { ...state.msftActionLoaderByReportKey, [key]: false },
        }
      }
      case FETCH_AFFECTED_MAILBOXES_COUNTS_ASYNC.SUCCESS:
        return {
          ...state,
          affMailboxesCounts: action.payload.data,
        }
      case FETCH_SCANS_FREEMIUM_LIMIT_ASYNC.INITIATE:
        return { ...state, reportLoader: true }
      case FETCH_SCANS_FREEMIUM_LIMIT_ASYNC.SUCCESS:
        return {
          ...state,
          scansFreemiumLimit: action.payload.data,
        }
      case REPORT_REQUEST_ASYNC.INITIATE:
      case ATO_REPORT_REQUEST_ASYNC.INITIATE:
        // A background refresh of the open incident must not reset the email
        // tab or the scanner / mailbox panes the analyst already opened.
        if (action.payload?.background) return state
        return {
          ...state,
          scannerDetails: null,
          affMailboxesDetails: null,
          // Drawer prev/next (and any re-fetch) must not keep Email Body/Snapshot/… from the prior report.
          escalatedEmailCardTabKey: EMAIL_TABS_KEYS.EMAIL_BODY,
        }
      case REPORT_REQUEST_ASYNC.SUCCESS: {
        const report = action.payload.data.report
        return {
          ...state,
          error: null,
          data: {
            ...report,
          },
          reportLoader: false,
        }
      }
      case COMMENTS_REQUEST_ASYNC.SUCCESS: {
        const { internalCount = 0, communityCount = 0 } = action.payload.data || {}
        return {
          ...state,
          data: {
            ...state.data,
            commentsCount: internalCount + communityCount,
          },
        }
      }
      case REPORT_REQUEST_ASYNC.ERROR:
        return {
          ...state,
          error: action.error,
          reportLoader: false,
        }
      case FETCH_ASSIGNEES_ASYNC.INITIATE: {
        return {
          ...state,
          assignees: { ...state.assignees, loader: true },
        }
      }
      case FETCH_ASSIGNEES_ASYNC.SUCCESS: {
        return {
          ...state,
          assignees: {
            loader: false,
            error: null,
            data: action.payload.data,
          },
        }
      }
      case FETCH_ASSIGNEES_ASYNC.ERROR:
        return {
          ...state,
          assignees: {
            loader: false,
            data: [],
            error: action.error.response?.message,
          },
        }
      case FETCH_COMMUNITY_INSIGHTS_ASYNC.INITIATE:
        return {
          ...state,
          communityLoader: true,
        }
      case FETCH_COMMUNITY_INSIGHTS_ASYNC.SUCCESS:
        return {
          ...state,
          communityLoader: false,
          communityInsights: action.payload.data,
        }
      case REPORT_STATE_CHANGE_ASYNC.ERROR:
      case FETCH_SCANS_FREEMIUM_LIMIT_ASYNC.ERROR:
      case CLOSE_INCIDENT_ASYNC.ERROR:
      case CLOSE_SAFE_CHALLENGE_INCIDENT_ASYNC.ERROR:
      case KEEP_ENCRYPTED_INCIDENT_IN_QUARANTINE_ASYNC.ERROR:
        return { ...state, error: action.error, reportLoader: false }
      case REPORT_STATE_CHANGE_ASYNC.CANCEL:
      case RELEASE_ENCRYPTED_INCIDENT_ASYNC.ERROR:
        return { ...state, reportLoader: false }
      case REPORT_ELEMENTS_UPDATE_ASYNC.INITIATE: {
        const { data } = state
        if (action.payload.elementsName === 'serversidescan') {
          const updatedData = {
            ...data,
            scans: data.scans?.map((elem) => ({
              ...elem,
              status: 'Pending',
            })),
          }
          return {
            ...state,
            data: updatedData,
          }
        } else if (
          action.payload.elementsName === 'links' ||
          action.payload.elementsName === 'attachments'
        ) {
          // Handle links and attachments in reportElements structure
          const key = action.payload.elementsName === 'attachments' ? 'files' : 'links'
          const updatedReportElements = { ...state.reportElements }

          // Update all pages of the element type
          Object.keys(updatedReportElements[key] || {}).forEach((pageKey) => {
            const pageData = updatedReportElements[key][pageKey]
            if (Array.isArray(pageData)) {
              updatedReportElements[key][pageKey] = pageData.map((elem) => ({
                ...elem,
                status: statusKeyMap.scanning,
              }))
            }
          })

          return {
            ...state,
            reportElements: updatedReportElements,
          }
        } else if (data[action.payload.elementsName]) {
          // Handle other element types that might still be in data
          const updatedData = {
            ...data,
            [action.payload.elementsName]: data[action.payload.elementsName].map((elem) => ({
              ...elem,
              status: statusKeyMap.scanning,
            })),
          }
          return {
            ...state,
            data: updatedData,
          }
        }
        return {
          ...state,
          data,
        }
      }
      case REPORT_ELEMENTS_REQUEST_ASYNC.SUCCESS: {
        const { data } = state
        // check if user didn't change report till updating cb is triggered.
        if (data.id === action.payload.reportId) {
          const updatedData = affectReportForElements(
            data,
            action.payload.data.elements,
            action.payload.elementsName
          )
          return {
            ...state,
            data: updatedData,
          }
        }
        return state
      }
      case TAGS_REQUEST_ASYNC.SUCCESS: {
        if (
          action.payload.reportId &&
          action.payload.reportType &&
          (action.payload.reportType === INCIDENT_TYPE.MAIL ||
            action.payload.reportType === INCIDENT_TYPE.TEAMS) &&
          action.payload.reportId === state.data.id
          // Here also need the check below, because different
          // report types might have the same id.
          // action.payload.reportType === state.data.reportType
          // But because there is no reportType inside report
          // reducer no way to check.
          // Two options how to resolve:
          // 1) think about storing it here
          // 2) return from BE
          // For now I consider it as an edge case.
        ) {
          return {
            ...state,
            data: {
              ...state.data,
              tags: action.payload.data.selectedTags,
            },
          }
        } else return state
      }
      case EDIT_TAGS_REQUEST_ASYNC.SUCCESS:
        if (action.payload.reportId === state.data.id) {
          return {
            ...state,
            data: {
              ...state.data,
              tags: action.payload.data,
            },
          }
        } else return state
      case SHOW_SCANNER_DETAILS_VIEW:
        return { ...state, scannerDetails: action.payload.data }
      case SHOW_AFFECTED_MAILBOXES_VIEW:
        return { ...state, affMailboxesDetails: action.payload.data }

      case DOWNLOAD_ORIGINAL_EMAIL_ASYNC.INITIATE:
        return { ...state, downloadOriginalEmailLoader: true }
      case DOWNLOAD_ORIGINAL_EMAIL_ASYNC.SUCCESS:
      case DOWNLOAD_ORIGINAL_EMAIL_ASYNC.ERROR:
        return { ...state, downloadOriginalEmailLoader: false }
      case EMAIL_SNAPSHOT_ASYNC.INITIATE: {
        return {
          ...state,
          emailSnapshotLoader: true,
        }
      }
      case EMAIL_SNAPSHOT_ASYNC.SUCCESS: {
        return {
          ...state,
          snapshotUrl: action.payload,
          emailSnapshotLoader: false,
        }
      }
      case EMAIL_SNAPSHOT_ASYNC.ERROR: {
        return {
          ...state,
          snapshotUrl: null,
          emailSnapshotLoader: false,
        }
      }
      case SET_ESCALATED_EMAIL_CARD_TAB_KEY: {
        return {
          ...state,
          escalatedEmailCardTabKey: action.payload.key,
        }
      }
      case FETCH_REPORT_ELEMENTS_ASYNC.INITIATE: {
        return {
          ...state,
          reportElements: {
            ...state.reportElements,
            loader: true,
          },
        }
      }
      case FETCH_REPORT_ELEMENTS_ASYNC.SUCCESS: {
        const { otype, page, data } = action.payload
        const key = otype === EMAIL_CONTENT_TYPE.LINKS ? 'links' : 'files'
        const pageKey = page || 1

        return {
          ...state,
          reportElements: {
            ...state.reportElements,
            loader: false,
            [key]: {
              ...state.reportElements[key],
              [pageKey]: data,
            },
          },
        }
      }
      case FETCH_REPORT_ELEMENTS_ASYNC.ERROR: {
        return {
          ...state,
          reportElements: {
            ...state.reportElements,
            loader: false,
            error: action.error,
          },
        }
      }
      case FETCH_REPORT_ELEMENTS_ASYNC.CANCEL: {
        return {
          ...state,
          reportElements: {
            ...state.reportElements,
            loader: false,
          },
        }
      }
      case FETCH_PAGINATED_REPORTERS_ASYNC.INITIATE: {
        return {
          ...state,
          reportersLoading: true,
        }
      }
      case FETCH_PAGINATED_REPORTERS_ASYNC.SUCCESS: {
        const { data } = action.payload
        const { results, ...rest } = data
        const pageKey = data.current_page || 1
        return {
          ...state,
          reportersLoading: false,
          reportersPagination: {
            ...state.reportersPagination,
            ...rest,
            results: state.reportersPagination.results
              ? { ...state.reportersPagination.results, [pageKey]: results }
              : { [pageKey]: results },
          },
        }
      }
      case FETCH_PAGINATED_REPORTERS_ASYNC.ERROR: {
        return {
          ...state,
          reportersLoading: false,
        }
      }
      case REQUEST_THEMIS_GENERATE_ASYNC.INITIATE: {
        const reportId = action.payload
        const existing = state.themisAnalysis.byReportId[reportId] || {}
        // A fresh, explicit user request to generate: set the intent and clear any
        // durable 402/error so a post-block re-click can re-attempt (mirrors the
        // manual-retry "fresh attempt" semantics). The auto-start effect reads the
        // intent; the intent is consumed at THEMIS_ANALYSIS_ASYNC.INITIATE.
        return {
          ...state,
          themisAnalysis: {
            ...state.themisAnalysis,
            byReportId: {
              ...state.themisAnalysis.byReportId,
              [reportId]: {
                ...existing,
                generateRequested: true,
                insufficientCredits: false,
                error: null,
              },
            },
          },
        }
      }
      case FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS: {
        // MSP tenant switch: drop any pending generate-intent so a stale intent
        // cannot auto-run against the newly-selected company (IC-49715).
        const byReportId = Object.fromEntries(
          Object.entries(state.themisAnalysis.byReportId).map(([id, entry]) => [
            id,
            { ...entry, generateRequested: false },
          ])
        )
        return {
          ...state,
          themisAnalysis: { ...state.themisAnalysis, byReportId },
        }
      }
      case THEMIS_ANALYSIS_ASYNC.INITIATE: {
        const { reportId, manual } = action.payload
        const existing = state.themisAnalysis.byReportId[reportId] || {}
        // A manual initiate is a fresh user-driven attempt: full reset including
        // the retry budget. An auto initiate (auto-start / auto-retry) must
        // reset only the streaming/data fields and PRESERVE the durable budget
        // so the per-report cap survives remount/incident-switching.
        return {
          ...state,
          themisAnalysis: {
            byReportId: {
              ...state.themisAnalysis.byReportId,
              [reportId]: {
                ...(manual ? {} : existing),
                loading: true,
                error: null,
                data: null,
                fieldLoadingStates: {},
                dynamicCards: {},
                dynamicTables: {},
                tasks: null,
                hasReceivedToolCallStart: false,
                isComplete: false,
                activityEvents: [],
                retryCount: manual ? 0 : existing.retryCount || 0,
                retryExhausted: manual ? false : existing.retryExhausted || false,
                // Durable "out of credits" flag: a manual retry is a fresh attempt
                // (clear it); an auto initiate preserves it so a 402 stays terminal.
                insufficientCredits: manual ? false : existing.insufficientCredits || false,
                // Consume the generate-intent at the spend event: once the request
                // fires, a later credit restore / remount / refresh cannot re-trigger
                // an auto-run (IC-49715).
                generateRequested: false,
              },
            },
          },
        }
      }
      case THEMIS_ANALYSIS_ASYNC.SUCCESS: {
        const { reportId } = action.payload
        const existing = state.themisAnalysis.byReportId[reportId] || {}
        return {
          ...state,
          themisAnalysis: {
            byReportId: {
              ...(CACHE_THEMIS_ANALYSIS_RESULTS ? state.themisAnalysis.byReportId : {}),
              [reportId]: {
                ...existing,
                loading: false,
                isComplete: true,
                retryCount: 0,
                retryExhausted: false,
                insufficientCredits: false,
              },
            },
          },
        }
      }
      case THEMIS_ANALYSIS_ASYNC.ERROR: {
        const { reportId } = action.payload || {}
        const existing = state.themisAnalysis.byReportId[reportId] || {}
        const retryCount = (existing.retryCount || 0) + 1
        return {
          ...state,
          themisAnalysis: {
            byReportId: {
              ...state.themisAnalysis.byReportId,
              [reportId]: {
                ...existing,
                loading: false,
                error: action.error,
                retryCount,
                retryExhausted: retryCount >= THEMIS_MAX_RETRIES,
                // A 402 sets the durable flag so the credit-exhausted screen and the
                // auto-start/retry guards survive the abort that clears `error`.
                insufficientCredits:
                  action.error === 'Insufficient credits' || existing.insufficientCredits || false,
              },
            },
          },
        }
      }
      case THEMIS_ANALYSIS_ASYNC.CANCEL: {
        const { reportId } = action.payload || {}
        const existing = state.themisAnalysis.byReportId[reportId] || {}
        // Abort is user navigation, not a failure: clear the phantom error so a
        // remount does not auto-retry, but PRESERVE the durable retry budget.
        return {
          ...state,
          themisAnalysis: {
            byReportId: {
              ...state.themisAnalysis.byReportId,
              [reportId]: {
                ...existing,
                loading: false,
                error: null,
              },
            },
          },
        }
      }
      case THEMIS_ANALYSIS_PARTIAL_UPDATE: {
        const { reportId, patch } = action.payload
        const existing = state.themisAnalysis.byReportId[reportId] || {}
        return {
          ...state,
          themisAnalysis: {
            byReportId: {
              ...state.themisAnalysis.byReportId,
              [reportId]: {
                ...existing,
                ...patch,
              },
            },
          },
        }
      }
      // case DOWNLOAD_EMAIL_ASYNC.ERROR: {
      //   const foundMailbox = state.data.affectedMailboxes.find(
      //     (mailbox) => mailbox.id === action.payload.id
      //   )
      //   if (foundMailbox) {
      //     foundMailbox.disabled = true
      //   }
      //   return {
      //     ...state,
      //     data: {
      //       ...state.data,
      //       affectedMailboxes: [...state.data.affectedMailboxes],
      //     },
      //   }
      // }
      default:
        return state
    }
  }
}
